// Core
import React, { Component } from 'react';

// Styles
import './styles.css';

import {__, STR_KEY} from '../../services/Translate';


export default class ExpandableContent extends Component {
    state = {
        isOpen: false,
        canExpand: false,
    }

    toggle(value) {
        this.setState({
            isOpen: value,
        });
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                canExpand: this.canExpand(),
            })
        })
    }

    /**
     * if the element height is equal to the closedHeight then we know
     * there is more content to show
     * 
     * @returns boolean
     */
    canExpand() {
        if (!this.refs.contentContainerRef) return false;

        let contentContainerHeight = this.refs.contentContainerRef.clientHeight;
        return contentContainerHeight >= this.props.closedHeight;
    }

    render() {
        const contentContainerStyle = (this.state.isOpen ? {} : { maxHeight: this.props.closedHeight, overflow: 'hidden'
     });

        return (
            <div>
                <div ref="contentContainerRef" className="ExpandableContent-contentContainer" style={contentContainerStyle}>
                    {this.props.children}
                    <Fade visible={!this.state.isOpen && this.state.canExpand}/>
                </div>

                {this.state.canExpand &&
                    <Button 
                        isOpen={this.state.isOpen} 
                        expand={() => this.toggle(true)} 
                        collapse={() => this.toggle(false)}
                        openLabel={this.props.openLabel}
                        closeLabel={this.props.closeLabel}
                    />
                }
            </div>
        )
    }
}

ExpandableContent.defaultProps = {
    closedHeight: 90
}

const Button = (props) => {
    if (props.isOpen) {
        return (
            <button 
                id="description-content-collapse"
                className="gecko-ui-btn btn btn-secondary" 
                onClick={() => props.collapse()}
                aria-label={__(STR_KEY.BTN_COLLAPSE)}
                aria-expanded="true"
            >
                <i className="fa fa-angle-up" /> {__(STR_KEY.BTN_COLLAPSE)}
            </button>
        );
    }

    return (
        <button 
            id="description-content-expand"
            className="gecko-ui-btn btn btn-secondary" 
            onClick={() => props.expand()}
            aria-label={__(STR_KEY.BTN_EXPAND)}
            aria-expanded="false"
        >
            <i className="fa fa-angle-down"/> {__(STR_KEY.BTN_EXPAND)}
        </button>
    )
}

Button.defaultProps = {
    isOpen: false,
    expand: () => {},
    collapse: () => {},
    openLabel: null,
    closeLabel: null
}

const Fade = (props) => {
    if (!props.visible) return null;
    return <div className="ExpandableContent-contentFade"/>;
}
